import { configureStore } from '@reduxjs/toolkit';
/* @ts-expect-error module is untyped */

import NotificationMiddleware from 'ReduxMessenger/middleware/NotificationMiddleware';
/* @ts-expect-error module is untyped */

import reviewFiltersMiddleware from '../middleware/reviewFilters';
import rootReducer from '../reducers';
const store = configureStore({
  reducer: rootReducer,
  middleware: getDefaultMiddleware =>
  /* TODO: allow serializableCheck - depends on removing Immutable.Map from
   * certifications reducer */
  getDefaultMiddleware({
    serializableCheck: false
  }).concat(NotificationMiddleware, reviewFiltersMiddleware)
});
export default store;